import { render, staticRenderFns } from "./UomTag.vue?vue&type=template&id=5660e8d3&"
import script from "./UomTag.vue?vue&type=script&lang=js&"
export * from "./UomTag.vue?vue&type=script&lang=js&"
import style0 from "./UomTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports